import React from 'react';

interface ItemCounterProps {
  selected: boolean | undefined;
  children: React.ReactNode;
}

export const ItemCounter = ({ selected = false, children }: ItemCounterProps): JSX.Element => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0 10px',
        marginLeft: '6px',
        backgroundColor: selected ? 'rgba(254, 226, 226, 1)' : 'rgba(0,0,0,0.05)',
        borderRadius: '10px',
        height: '20px',
        color: selected ? '#B91C1C' : 'black',
        fontSize: '12px',
        fontWeight: 500
      }}
    >
      {children}
    </div>
  );
};
